/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import { useState } from 'react';
import { userService, CoachCourseDashboard } from '../services/userService';

export function useCoachCourseDashboard() {
	const [dashboard, setDashboard] = useState<CoachCourseDashboard | null>(
		null
	);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchDashboard = async (filters?: {
		courseId?: string;
		inviteStatus?: string;
		search?: string;
		page?: number;
		limit?: number;
	}) => {
		setLoading(true);
		setError(null);

		try {
			const data = await userService.getCoachCourseDashboard(filters);
			setDashboard(data);
		} catch (err: any) {
			console.error('Error fetching coach dashboard:', err);
			setError(err.message || 'Failed to fetch dashboard');
		} finally {
			setLoading(false);
		}
	};

	return {
		dashboard,
		loading,
		error,
		fetchDashboard,
	};
}
